import Gutter from "ui-kit/Gutter";
import { Typography } from "ui-kit/Typography";
import styles from "./LiabilityAddonBox.module.css";
import Switch from "ui-kit/Switch/Switch";
import { ReactNode, useState } from "react";
import { useWebTranslation } from "translations";
import { useLottieAnimation } from "hooks/useLottieAnimation";
import { Badge, Modal } from "ui-kit";
import Colors from "ui-kit/colors";

type Props = {
  title: string;
  summary: ReactNode;
  readmore?: ReactNode;
  options: { title: ReactNode; onChange: VoidFunction; isActive: boolean }[];
  badge?: string;
};

export const LiabilityAddonBox = ({
  title,
  summary,
  readmore,
  options,
  badge,
}: Props) => {
  const { t } = useWebTranslation();
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.text}>
          <div className={styles.titleRow}>
            <Typography variant="body2">
              <strong>{title}</strong>
            </Typography>
            {badge && <Badge text={badge} color={Colors.sun200} />}
          </div>
          <Gutter size={0.5} />
          <Typography variant="body3" color="grey500">
            {summary}
          </Typography>
          {readmore && (
            <button
              className={styles.readMore}
              style={{ display: "block" }}
              onClick={() => setShowOverlay(true)}
            >
              <Typography variant="body3" color="blue300">
                <strong>{t("global.read_more")}</strong>
              </Typography>
            </button>
          )}
        </div>
      </div>
      <div className={styles.bottomBar}>
        {options.map((option, index) => (
          <div key={index} className={styles.option}>
            <Typography variant="body3" color="black" id={`option-${index}`}>
              <strong>{option.title}</strong>
            </Typography>
            <Switch
              active={option.isActive}
              activeColor="blue300"
              aria-labelledby={`option-${index}`}
              onChange={option.onChange}
            />
          </div>
        ))}
      </div>

      <Modal
        isOpen={showOverlay}
        onClose={() => setShowOverlay(false)}
        title=""
      >
        <Typography variant="body2">{readmore}</Typography>
      </Modal>
    </div>
  );
};
